import Vue from "vue";
import { mapGetters } from "vuex";

import { CurrencyText } from "@/components/";

import { GridUtil, PartDetailServices, ErrorLogService } from "@/services";

export default Vue.extend({
    name: "CoreDeductionsTab",

    components: { CurrencyText },
    computed: {
        ...mapGetters(["user", "getContentItem", "billingCurrencyCode", "activeAccountId"]),
    },

    props: {
        partId: {
          type: Number,
          default: 0,
        }
    },

    created() {
        this.columns = GridUtil.localizeColumnLabels(this.columns, this.getContentItem);
    },

    data: () => ({
        columns: [
            { key: "Description", localizationKey: "Description" },
            { key: "DeductionAmount", localizationKey: "DeductionAmount" },
        ],
        coreDeductions: {},
        loadingCoreDeductions: false,
        haveSuccessfullyLoadedCoreDeductions: false,
    }),
    methods: {
        async getCoreDeductions() {
            try {
                this.loadingCoreDeductions = true;

                const params = {
                    accountId: this.activeAccountId,
                    userId: this.user.UserId,
                    partId: this.partId
                };
                const data = await PartDetailServices.getCoreDeductions(params);

                this.coreDeductions =  data.Items;
                this.haveSuccessfullyLoadedCoreDeductions = true;
            } catch (err) {
                ErrorLogService.LogException(err);
            } finally {
                this.loadingCoreDeductions = false;
            }
        },
        loadTabData(){
            if(!this.haveSuccessfullyLoadedCoreDeductions && !this.loadingCoreDeductions){
                this.getCoreDeductions();
            }      
        }
    },
});
